<template>
  <div class="swiper-container">
    <div class="swiper-wrapper" v-show="show">
      <div class="item swiper-slide flex-fs" v-for="(item,i) in list" :key='i'>
        <div class="avatar">
          <img :src="item.customer_photo_path+'?imageMogr2/thumbnail/60x'" alt="">
        </div>
        <div class="flex-1">
          <div>{{ item.service_project_name }}</div>
          <div class="flex-sb">
            <div>{{ item.customer_name }}</div>
            <div><span>服务时间：{{ item.service_start_time }}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper, {
    Navigation,
    EffectFade,
    Autoplay
  } from 'swiper';
  Swiper.use([Navigation, EffectFade, Autoplay]);
  var that;
  export default {
    props: {
      list: {
        type: Array,
        default () {
          return []
        }
      }
    },
    data() {
      return{
        show: false,
        loop: false
      }
    },
    created() {
      that = this
      setTimeout(()=>{
        this.myswiper()
      },100)
    },
    methods: {
      myswiper: function() {
        var swiper = new Swiper('.swiper-container', {
          autoplay:{
            delay: 2500, 
            disableOnInteraction: false
          },
          speed: 1500,
          loop: true,
          direction: "vertical",
          slidesPerView: 4,
          observer: true, 
          observeParents: true,
          onSlideChangeStart: function(swiper){
            // setTimeout(()=>{
            //   that.loop = true
            // },100)
          }
        });
        this.show = true
      }
    }
  }
</script>

<style lang="scss" scoped>
  .swiper-container{
    width: 100%;
    height: 100%;
  }

  .item {
    width: 100%;
    padding: 0 13px;
    box-sizing: border-box;
    margin-bottom: 15px;
    background: linear-gradient(to right, #073264, #0A1E3B);
    height: 84px!important;
    .avatar {
      width: 60px;
      height: 75px;
      background: linear-gradient(to bottom, #0451A2, #08366C);
      padding: 4px;
      margin-right: 13px;
  
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  
    div {
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 30px;
      span{
        display: inline-block;
        transform: scale(0.78);
      }
    }
  }
</style>
